import {usePing} from "./usePing";
import {useMedia} from "./useMedia";
import {useDispatch, useSelector, useStore} from "react-redux";
import useVast from "./useVast";
import {useCallback, useEffect} from "react";
import ReactDOM from "react-dom";
import {AppDispatch} from "../../Store";
import {PlayedMount} from "../state/types";
import {AppState} from "../state";


export const Player = () => {
    const dispatch = useDispatch<AppDispatch>();
    const store = useStore<AppState>()
    const getElement = useCallback(()=>{
        let element = document.getElementById('rczplayer');
        if (!element) {
            element = document.createElement("div");
            element.id = 'rczplayer';
            document.body.appendChild(element);
        }
        return element as HTMLDivElement;
    },[]);
    const playingState = useSelector((state: AppState) => state.status);
    const Ping = usePing();
    const Media = useMedia();
    const Vast = useVast();
    const selection = [Ping, Media, Vast/*, Image */];
    const Render = selection.filter(item => !!item)[0]

    useEffect(() => {
        if (playingState !== "STOPPED") {
            return () => {
                const status = store.getState().status;
                if (status === "STOPPED")
                {
                    if (document.visibilityState === "hidden")
                        document.location.reload();
                }
            }
        }
    }, [playingState]);

    useEffect(() => {
        dispatch<PlayedMount>({
            type: "PlayerMount",
            payload: "Mount"
        })
        // eslint-disable-next-line
    }, []);

    if ((!Render || Render === true)) {
        return null;
    }


    // @ts-ignore
    return ReactDOM.createPortal(Render === false || Render === true ? null : Render() , getElement());

}

export default Player;